(ns portal.third-party-credentials.view
  (:require ["@mui/material/Box$default" :as Box]
            ["@mui/material/Button$default" :as Button]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/Typography$default" :as Typography]
            [common.flags :refer [use-flag]]
            [portal.third-party-credentials.cm360-table :refer [cm360-table]]
            [portal.third-party-credentials.meta-table :refer [social-credentials-table]]
            [portal.third-party-credentials.ocp]
            [re-frame.core :as rf]
            [uix.core :as uix :refer [$ defui]]))

(defui third-party-credentials []
  (let [cm360-enabled? (use-flag :decision-tree-generate-external-trackers)]
    ($ Stack {:spacing 4}
       ($ Stack {:direction "row"
                 :alignItems "center"
                 :justifyContent "space-between"
                 :sx #js {:py 2.5}}
          ($ Typography {:variant "h2"} "Meta credentials")
          ($ Button {:variant "contained"
                     :onClick #(rf/dispatch [:ocp/open {:id :social/config}])}
             "Add configuration"))
       ($ social-credentials-table)
       (when cm360-enabled?
         ($ Box
            ($ Typography {:variant "h2" :sx #js {:py 2.5}} "CM360 credentials")
            ($ cm360-table))))))
